import { createStore, applyMiddleware } from 'redux';

import createSagaMiddleware from 'redux-saga';
import ravenMiddleware from '../../core/js/middleware/raven';
import { constructTealiumMiddleware, coreTags } from '../../core/js/middleware/analytics';

import { initialState as coreInitialState } from '../../core/js/store';
import helpInitialState from './init/helpInitialState';

import helpApp from './reducers/helpApp';
import {
    storeLogger
} from '../../core/js/middleware/logger';

export const initialState = Object.assign({}, coreInitialState, helpInitialState, {
    core: Object.assign({}, coreInitialState.core, {
        pageType: 'help'
    })
});

export function configureStore() {
    const tealiumMiddleware = constructTealiumMiddleware([coreTags()]);
    const sagaMiddleware = createSagaMiddleware();
    const createStoreWithMiddleware = createStore(
        helpApp,
        initialState,
        applyMiddleware(storeLogger('Help'), ravenMiddleware, tealiumMiddleware, sagaMiddleware)
    );
    return Object.assign({}, createStoreWithMiddleware, { runSaga: sagaMiddleware.run });
}
